<div class="search-wrapper">
  <mat-form-field appearance="outline">
    <mat-label>Search</mat-label>
    <input #searchInput matInput>
  </mat-form-field>
</div>

<cdk-virtual-scroll-viewport #scroller itemSize="72" class="content">
  <mat-list>
    <ng-container *cdkVirtualFor="let file of files; last as last">
      <mat-list-item class="list-item" (click)="showFileInfo(file)">
          <span class="file-name">{{file.fileName}}</span>
        <mat-divider *ngIf="!last"></mat-divider>
      </mat-list-item>
    </ng-container>
    <div class="spinner-item" *ngIf="loading">
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
    </div>
  </mat-list>
</cdk-virtual-scroll-viewport>
